import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Perfil/updatePassword`, method: 'POST', body: values, token: token})
}
